import createIcon from '../../createIcon';

/**
 * @component @name Unsubscribe
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTggMTMuNUMxNi4wNyAxMy41IDE0LjUgMTUuMDcgMTQuNSAxN0MxNC41IDE4LjkzIDE2LjA3IDIwLjUgMTggMjAuNUMxOS45MyAyMC41IDIxLjUgMTguOTMgMjEuNSAxN0MyMS41IDE1LjA3IDE5LjkzIDEzLjUgMTggMTMuNVpNMjAgMTcuNUgxNlYxNi41SDIwVjE3LjVaTTEzLjA1IDE3LjVDMTMuMDMgMTcuMzMgMTMgMTcuMTcgMTMgMTdDMTMgMTQuMjQgMTUuMjQgMTIgMTggMTJDMTguOTIgMTIgMTkuNzYgMTIuMjYgMjAuNSAxMi42OVY1LjVDMjAuNSA0LjQgMTkuNiAzLjUgMTguNSAzLjVINC41QzMuNCAzLjUgMi41IDQuNCAyLjUgNS41VjE1LjVDMi41IDE2LjYgMy40IDE3LjUgNC41IDE3LjVIMTMuMDVaTTExLjUgMTFMNC41IDcuNVY1LjVMMTEuNSA5TDE4LjUgNS41VjcuNUwxMS41IDExWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Unsubscribe = createIcon('Unsubscribe', [
  [
    'path',
    {
      d: 'M18 13.5C16.07 13.5 14.5 15.07 14.5 17C14.5 18.93 16.07 20.5 18 20.5C19.93 20.5 21.5 18.93 21.5 17C21.5 15.07 19.93 13.5 18 13.5ZM20 17.5H16V16.5H20V17.5ZM13.05 17.5C13.03 17.33 13 17.17 13 17C13 14.24 15.24 12 18 12C18.92 12 19.76 12.26 20.5 12.69V5.5C20.5 4.4 19.6 3.5 18.5 3.5H4.5C3.4 3.5 2.5 4.4 2.5 5.5V15.5C2.5 16.6 3.4 17.5 4.5 17.5H13.05ZM11.5 11L4.5 7.5V5.5L11.5 9L18.5 5.5V7.5L11.5 11Z',
      key: '15ftz3',
    },
  ],
]);

export default Unsubscribe;
